import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { Checkbox, Form } from "antd";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { FilterProps } from "../../course-list/preview/Filters";
import { useCurriculumStore } from "../../../../stores/stores";
import { getIndustryCurriculum } from "../../../../service/curriculum/curriculum-service";
import { MenuItem } from "../../../../types/sidebar";
import { IndustryInfo } from "../../../../types/course";

export const useFilters = ({ hasPaid = false }: FilterProps) => {
  const params = useParams();
  const university = params?.id || "";
  const { industrieCurriculum, setIndustrieCurriculum } = useCurriculumStore();

  useEffect(() => {
    const getGroupOfIndustry = async () => {
      const res = await getIndustryCurriculum({ universities: [university] });
      setIndustrieCurriculum(res.data.data);
    };
    getGroupOfIndustry();
  }, []);

  const filterMenus: MenuItem[] = [
    {
      label: t("Chuyên ngành", "Chuyên ngành"),
      key: "industries",
      className: "course-filter-menu",
      children: industrieCurriculum?.map((item: IndustryInfo) => ({
        label: (
          <Form.Item name={`industry-${item.code}`} valuePropName="checked">
            <Checkbox>
              {item.name} {"("}
              {item.count}
              {")"}
            </Checkbox>
          </Form.Item>
        ),
        key: `industry-${item.code}`,
      })),
    },
  ];

  return filterMenus;
};
